import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsShort() {
  const testimonials = [{
    initials: 'MG',
    text: 'Usé ChatGPT el primer día y cerré una venta que tenía fría hace 3 semanas. El prompt de seguimiento fue clave.',
    author: 'Mariana G., Córdoba',
    role: 'Dueña de tienda de indumentaria'
  }, {
    initials: 'LP',
    text: 'El calendario de contenido me salvó. Ahora publico todos los días sin quedarme sin ideas. Y se nota en las ventas.',
    author: 'Lucas P., Rosario',
    role: 'Emprendedor gastronómico'
  }, {
    initials: 'RM',
    text: 'Automaticé los pedidos de WhatsApp en una tarde. Ahora respondo el doble de consultas en la mitad del tiempo.',
    author: 'Roberto M., Buenos Aires',
    role: 'Servicios de instalaciones'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-286">
      <div className="text-center mb-12" data-id="element-287">
        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-288">
          ⭐ Lo que dicen los que ya lo tienen
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6" data-id="element-289">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-brand-dark border border-brand-violet/30 rounded-2xl p-6 relative overflow-hidden group hover:border-brand-violet transition-colors" data-id="element-290">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-violet to-brand-gold opacity-50" data-id="element-291" />

            <div className="flex items-center gap-4 mb-4" data-id="element-292">
              <div className="w-12 h-12 rounded-full bg-brand-violet/20 flex items-center justify-center text-brand-violet font-bold text-lg border border-brand-violet/30" data-id="element-293">
                {t.initials}
              </div>
              <div className="flex gap-1" data-id="element-294">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-295" />)}
              </div>
            </div>

            <p className="text-gray-300 mb-6 italic" data-id="element-296">"{t.text}"</p>

            <div data-id="element-297">
              <p className="text-white font-semibold" data-id="element-298">{t.author}</p>
              <p className="text-sm text-gray-400" data-id="element-299">{t.role}</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}